export enum PayoutStatus {
  Pending = 10,
  Settled = 20,
  Cancelled = -10,
}
